import { render, staticRenderFns } from "./taskSetting.vue?vue&type=template&id=cbfa9404&scoped=true"
import script from "./taskSetting.vue?vue&type=script&lang=js"
export * from "./taskSetting.vue?vue&type=script&lang=js"
import style0 from "./taskSetting.vue?vue&type=style&index=0&id=cbfa9404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfa9404",
  null
  
)

export default component.exports